module.exports = __webpack_public_path__ + "static/media/1.f7fb2b61.jpg";